import { createReducerFromMap } from "@coverme/redux";
import * as stringService from "../../services/stringService";

const initialState = [];

function updateHouseholdMembers(state, data) {
    return data.value?.map(x => ({
        ...x,
        fullName: stringService.getFormattedNameFromObject(x),
        age: stringService.getAge(x.dateOfBirth),
    }));
}

function addHouseholdMember(state, action) {
    const addedHouseholdMember = {
        ...action.value,
        fullName: stringService.getFormattedNameFromObject(action.value),
        age: stringService.getAge(action.value.dateOfBirth),
    };
    return [...state, addedHouseholdMember];
}

function updateHouseholdMember(state, action) {
    return state.map(x => {
        if (x.personId !== action.value.personId) {
            return x;
        }

        return {
            ...x,
            ...action.value,
            fullName: stringService.getFormattedNameFromObject(action.value),
            age: stringService.getAge(action.value.dateOfBirth),
        };
    });
}

function deleteHouseholdMember(state, data) {
    const householdMemberToDelete = data.value;
    return state.filter(x => x.personId !== householdMemberToDelete);
}

function getInterview(state, action) {
    if (action.value.householdMembers && action.value.householdMembers.length > 0) {
        return updateHouseholdMembers(state, { value: action.value.householdMembers });
    }

    return state;
}

function resetInterview(state, action) {
    return initialState;
}

export const householdMembersReducer = createReducerFromMap(initialState, {
    UPDATE_HOUSEHOLD_MEMBERS_COMPLETE: updateHouseholdMembers,
    ADD_HOUSEHOLD_MEMBER_COMPLETE: addHouseholdMember,
    UPDATE_HOUSEHOLD_MEMBER_COMPLETE: updateHouseholdMember,
    DELETE_HOUSEHOLD_MEMBER_COMPLETE: deleteHouseholdMember,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
